import { render, staticRenderFns } from "./AppTeamPlugins.vue?vue&type=template&id=5cd39c1a&"
import script from "./AppTeamPlugins.vue?vue&type=script&lang=js&"
export * from "./AppTeamPlugins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports